import * as actionTypes from './../../actionTypes/ditto';

const initialState = {
    dittoSaved: false,
    addDittoProfile: null
};

export default function ditto(prevState = initialState, action) {
    switch (action.type) {
        case actionTypes.SAVE_UPDATE_DITTO_LOAD:
            return Object.assign({}, prevState, {
                dittoSaved: false,
            });
        case actionTypes.SAVE_UPDATE_DITTO_SUCCESS:
            return Object.assign({}, prevState, {
                dittoSaved: true,
            });
        case actionTypes.SAVE_UPDATE_DITTO_FAIL:
            return Object.assign({}, prevState, {
                dittoSaved: false,
            });
        case actionTypes.ADD_DITTO_LOAD:
            return Object.assign({}, prevState, {
                dittoSaved: false,
            });
        case actionTypes.ADD_DITTO_SUCCESS:
            return Object.assign({}, prevState, {
                addDittoProfile: action.data,
                dittoSaved: true
            });
        case actionTypes.ADD_DITTO_FAIL:
            return Object.assign({}, prevState, {
                addDittoProfile: action.error,
                dittoSaved: false,
            });
        default:
            return prevState;
    }
}
